import React from 'react'
import { ControlLabel } from '../label/Label'
import CalendarComp from '../calendar/CalendarComp'

const LabeledCalendar = ({
  idLabel,
  required,
  name,
  value,
  onChange,
  hourFormat,
  disabled,
  maxDate,
  minDate,
  showTime,
}) => {
  return (
    <div className="flex-container">
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <CalendarComp
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          showTime={showTime || false}
          hourFormat={hourFormat}
          maxDate={maxDate}
          minDate={minDate}
          disabled={disabled}
        />
      </div>
    </div>
  )
}

export default LabeledCalendar
